<!--賞与明細-->
<template>
  <div>
    <div class="all_area_p0003">
      <div class="search-module_p0003">
      </div>
      <div class="el-detail_p0003">
        <el-row>
          <div class="table-header">
            <!--年月＋画面名-->
            <span>{{this.title}}</span>
          </div>
        </el-row>
        <el-row style="padding-bottom: 10px;">
          <table class="p0003-table table-label">
            <!--項目名称 項目内容-->
            <tr v-for="(item,index) in tableList">
              <td class="table-header" v-if="item.itemValue == 'TITLE'" colspan="3">{{item.itemName}}</td>
              <td class="p0003-form-label" v-if="item.itemValue != 'TITLE'">{{item.itemName}}</td>
              <td class="p0003-form-value" v-if="(item.itemValue == null || item.itemValue == '') && item.itemValue != 'TITLE'"></td>
              <td class="p0003-form-value" v-if="(item.itemValue != null && item.itemValue != '') && item.itemValue != 'TITLE'">{{item.itemValue}}</td>
            </tr>
          </table>
        </el-row>
      </div>
      <div>
        <el-row style="text-align:center;">
          <!--戻る-->
          <el-button class="css-btn css-button" type="primary" style="margin-left: 25px;font-size: 13px;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
          <i class="el-icon-document" v-if="this.pdfFileUrl" style="margin-top: 4px;margin-right: 10px;font-size: 30px; color: #409eff;float:right;" @click="download_click"></i>
        </el-row>
      </div>
    </div>
    <el-dialog fullscreen :visible.sync="viewVisible" :close-on-click-modal="false" :show-close="false" width="100%" top="52px" height="120%">
      <Pdf :src="pdfUrl" @pdfClose="pdfClose"></Pdf>
    </el-dialog>
  </div>
</template>
<script>
import * as amsApi from "../api/p_0003"
import css from "@/statics/css"
import pdf from '@/components/page/pdf'
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  components: {
    Pdf: pdf
  },
  data() {
    return {
      title: '',
      type: '',
      yearMonthDay: '',
      itemsList: [],
      tableList: [],
      pdfFileUrl: '',
      //PDF
      viewVisible: false,
      pdfUrl: '',
    }
  },
  methods: {
    // 戻る処理
    back_click() {
      var returnP0001Param = JSON.parse(localStorage.getItem('P0001search_condition'));
      var vm = this;
      vm.$router.push({ path: url.routerUrl_P0001, query: returnP0001Param });
    },
    //PDFダウンロード
    download_click() {
      if (this.pdfFileUrl != null && this.pdfFileUrl.length != 0) {
        this.set_loading()
        amsApi.p_0003GetFile(this.pdfFileUrl).then(res_file => {
          let fileUrl = {}
          let blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' })
          let url = window.URL.createObjectURL(blob)
          fileUrl.url = url
          fileUrl.name = this.pdfFileUrl
          for (let index = 0; index < 2; index++) {
            fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1)
          }
          this.download(fileUrl)
          this.close_loading()
        }).catch((err) => {
          //关闭loading
          this.close_loading()
        });
      }
    },
    pdfClose() {
      this.viewVisible = false
    },
    //pdfダウンロード
    download(file) {
      this.pdfUrl = file
      this.viewVisible = true
    },
  },
  // 初期化
  created() {
    this.obj = JSON.parse(localStorage.getItem('obj'));
    //賞与
    this.type = "2";
    this.title = this.obj.paidDate.slice(0, 4) + "年" + this.obj.paidDate.slice(5, 7) + "月" + " " + this.$t('MODULE.P0003_TITLE');
    this.yearMonthDay = JSON.parse(JSON.stringify(this.obj.paidDate.replace(new RegExp("-", 'g'), "/")));

    var params = {
      paidDate: this.yearMonthDay,
      type: this.type,
      userCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
    }

    //給与明細検索
    amsApi.p_0003Query(params).then(res => {
      if (res.code == 300) {
        this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
        this.itemsList = []
        return
      } else if (res.code == 204) {
        this.itemsList = res.items.paymentDetailSet;
        this.pdfFileUrl = res.items.paymentPathSet[0].formPath;
        this.tableList = [];
        for (var i = 0; i < this.itemsList.length; i++) {
          var items_T = {
            itemId: this.itemsList[i].itemId,
            itemName: this.itemsList[i].itemTitle,
            itemValue: "TITLE"
          }
          this.tableList.push(items_T);
          for (var j = 0; j < this.itemsList[i].itemContent.length; j++) {
            //APIから「様式」には、「day」が場合、APIから「項目値」の後に、【日】を付ける
            if (this.itemsList[i].itemContent[j].itemStyle == "day" && this.itemsList[i].itemContent[j].itemValue != "" && this.itemsList[i].itemContent[j].itemValue != null) {
              this.itemsList[i].itemContent[j].itemValue = this.itemsList[i].itemContent[j].itemValue + "日";
            }
            //APIから「様式」には、「money」が場合、APIから「項目値」は、【999,999,999】
            if (this.itemsList[i].itemContent[j].itemStyle == "money" && this.itemsList[i].itemContent[j].itemValue != "" && this.itemsList[i].itemContent[j].itemValue != null && this.itemsList[i].itemContent[j].itemValue.toString().length > 3) {
              this.itemsList[i].itemContent[j].itemValue = this.itemsList[i].itemContent[j].itemValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            }
            var items_V = {
              itemId: this.itemsList[i].itemContent[j].itemId,
              itemName: this.itemsList[i].itemContent[j].itemName,
              itemValue: this.itemsList[i].itemContent[j].itemValue
            }
            this.tableList.push(items_V);
          }
        }
        //給与確認情報保存
        amsApi.p_0003Save(params, JSON.parse(localStorage.getItem('userInfo')).userCd).then(res => {
          if (res.code != 202) {
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true })
          }
        });
      }
    });
  }
}
</script>
<style scope>
/*panel下全部区域*/
.all_area_p0003 {
  margin-left: 0px;
}
/*下半部整体div样式*/
.el-detail_p0003 {
  width: 100%;
  height: 100%;
}
.search-module_p0003 {
  padding-bottom: 1px;
  margin-bottom: 1px; /*检索模块与表格间距*/
  width: 100%;
  background-image: linear-gradient(#ffffff, #ffffff);
}
.p0003-table.el-table td {
  padding: 0px 0;
}
/* 表格边框、字体样式 */
.p0003-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.p0003-table,
.p0003-table tr td {
  border: 1px solid #ccc;
}
/* 表格内边距 */
.p0003-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.p0003-form-label {
  text-align: right;
  width: 110px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.p0003-form-value {
  background: #fafafa;
}
</style>


// WEBPACK FOOTER //
// src/module/page/p_0003.vue